export default "__VITE_ASSET__DcpSIoUa__"